import { useEffect, useState } from 'react'
import Mascot from './Mascot'
import { BUILD_DATE } from './data'
import { useT } from './i18n'
import { MONO as FONT_MONO } from './ui'

const MONO = FONT_MONO
const SEEN_KEY = 'inh-welcome'
const COUNT_MS = 1500

/** First-visit curtain: pixel mascot builds, wordmark rises out of a mask, a counter runs to 100, then the curtain lifts and the hero animates in. */
export default function Welcome() {
  const { t } = useT()
  const [show, setShow] = useState(false)
  const [n, setN] = useState(0)
  const [leaving, setLeaving] = useState(false)

  useEffect(() => {
    const root = document.documentElement
    if (root.dataset.intro !== 'run') return
    setShow(true)
    document.body.style.overflow = 'hidden'
    try { sessionStorage.setItem(SEEN_KEY, '1') } catch { /* private mode */ }
    let raf = 0, t1 = 0, t2 = 0
    const t0 = performance.now()
    const tick = (now: number) => {
      const p = Math.min(1, (now - t0) / COUNT_MS)
      setN(Math.round(100 * (1 - Math.pow(1 - p, 2.2))))
      if (p < 1) raf = requestAnimationFrame(tick)
      else t1 = window.setTimeout(leave, 250)
    }
    const leave = () => {
      setLeaving(true)
      root.dataset.intro = 'done' // hero starts revealing as the curtain lifts
      t2 = window.setTimeout(() => { setShow(false); document.body.style.overflow = '' }, 1000)
    }
    raf = requestAnimationFrame(tick)
    return () => { cancelAnimationFrame(raf); clearTimeout(t1); clearTimeout(t2); document.body.style.overflow = ''; root.dataset.intro = 'done' }
  }, [])

  if (!show) return null
  return (
    <div className={'welcome' + (leaving ? ' leaving' : '')} role="status" aria-label={t('welcome.loading')} onClick={() => setN(100)}>
      <div className="welcome-top"><span>{t('welcome.top')}</span><span>{t('welcome.place', { year: BUILD_DATE.slice(0, 4) })}</span></div>
      <div className="welcome-mid" lang="en">
        <span style={{ display: 'block', width: 72, height: 78 }}><Mascot build /></span>
        <div className="mask"><span className="rise" style={{ animationDelay: '.35s' }}>InvoiceNow</span></div>
        <div className="mask"><span className="rise" style={{ animationDelay: '.5s', color: '#f2f6f4' }}>Hub</span></div>
      </div>
      <div className="welcome-bottom">
        <span className="welcome-count" style={{ fontFamily: MONO }}>{String(n).padStart(3, '0')}</span>
        <span style={{ fontFamily: MONO, fontSize: 12, letterSpacing: '0.1em' }}>{t('welcome.tagline')}</span>
      </div>
      <div className="welcome-bar" style={{ transform: `scaleX(${n / 100})` }} />
    </div>
  )
}
